import Link from "@components/Link";
import ThickChinaAvatarIcon from "@src/app/assets/author-placeholder.svg";
import type { BFFArticleCard, BFFAuthorDetail } from "@src/app/types/bff";
import type { ReactElement } from "react";
type Props = Readonly<{
  author: BFFArticleCard["authors"][0] | BFFAuthorDetail;
}>;

export default function ContributorCard({ author }: Props): ReactElement {
  return (
    <Link
      data-testid={`contributor-card-${author.id}`}
      to={author.urlPath || ""}
      className="group text-label-2 text-primary bg-background-secondary flex items-start gap-2 p-4"
    >
      <img
        src={author.imageUrl || ThickChinaAvatarIcon}
        alt={author.name}
        className="aspect-square size-20 rounded-full"
      />

      <div>
        <h4
          className={
            "text-header-4 text-primary group-hover:text-link-hover font-bold group-hover:cursor-pointer"
          }
        >
          {author.name}
        </h4>
        {author.designation && (
          <span className={"text-label-2 text-tertiary block font-bold"}>
            {author.designation}
          </span>
        )}
      </div>
    </Link>
  );
}
